import { Box } from '@mui/material'
import { get, keys } from 'lodash-es'
import { useMemo } from 'react'
import { ItemViewModel, UsedItem } from 'store/models/sellModels'
import { getItemPrice } from 'utilities/price/getPrice'
import { CartModifierRow } from './CartModifierRow'
import { CartVariantOptionRow } from './CartVariantOptionRow'
import { DisplayLine } from './CartItemDetail'
import { useCartContext } from './CartContext'
import OrderItemViewError from 'store/utils/OrderItemViewError'

interface CartComboRowProps {
    lineId: string
    comboItemId: string
    comboChoiceId: string
    usedItem: UsedItem
    menuId: string | undefined
    itemQuantity: number
    isReadonly?: boolean
    isOrderLineVoided?: boolean
}
export const CartComboRow = ({
    lineId,
    comboItemId,
    comboChoiceId,
    usedItem,
    menuId,
    itemQuantity = 1,
    isReadonly,
    isOrderLineVoided,
}: CartComboRowProps) => {
    const {
        itemsMap,
        comboChoicesMap,
        priceListData,
        removedData,
        unavailableProducts,
        variantGroupsMap,
        modifierOptionsMap,
        entityModifiersMap,
    } = useCartContext()

    const item: ItemViewModel | undefined =
        itemsMap[usedItem.nodeItemId] ||
        get(removedData.itemsMap ?? {}, usedItem.nodeItemId)
    const name = item?.displayName || item?.name
    const currentComboItem =
        comboChoicesMap[comboItemId]
            ?.find((a) => a.comboChoiceID === comboChoiceId)
            ?.comboItems.find((a) => a.itemID === usedItem.nodeItemId) ||
        (removedData.comboChoicesMap ?? {})[comboItemId]
            ?.find((a) => a.comboChoiceID === comboChoiceId)
            ?.comboItems.find((a) => a.itemID === usedItem.nodeItemId)

    const price = getItemPrice(
        currentComboItem?.comboChoiceItemId!,
        menuId,
        priceListData,
    )
    // Note: To do improve code
    const isActive = useMemo(() => {
        let errors = new OrderItemViewError(
            false,
            [],
            comboChoicesMap,
            unavailableProducts,
            false,
            modifierOptionsMap,
            {} as any,
            variantGroupsMap,
            {} as any,
            {} as any,
            entityModifiersMap,
        )
        errors.validateComboChoices(
            comboItemId,
            name,
            [
                errors.buildComboItemFromView(
                    usedItem,
                    comboChoicesMap[comboItemId],
                    usedItem.comboChoiceId,
                ),
            ],
            comboChoiceId,
            undefined,
            menuId!,
        )
        return errors.errors['item-unavailable'].length === 0
    }, [
        comboChoicesMap,
        unavailableProducts,
        modifierOptionsMap,
        variantGroupsMap,
        comboItemId,
        name,
        usedItem,
        comboChoiceId,
        menuId,
        entityModifiersMap,
    ])
    return (
        <Box>
            <DisplayLine
                name={name}
                price={price * usedItem.quantity}
                quantity={usedItem.quantity}
                isActive={isActive || isReadonly}
                isBaseItem
                hidePrice={isOrderLineVoided}
            />
            <Box pl={4}>
                <CartVariantOptionRow
                    usedVariants={usedItem.usedVariants}
                    comboVariantOptions={
                        currentComboItem?.variantGroups.flatMap(
                            (a) => a.variantOptions,
                        ) ?? []
                    }
                    itemQuantity={
                        (usedItem.isFixedItem ? 1 : usedItem.quantity) *
                        itemQuantity
                    }
                    isOrderLineVoided={isOrderLineVoided}
                />
                {keys(usedItem.usedModifiers).map((mo) => {
                    return (
                        <CartModifierRow
                            key={`modifier-option-row-${mo}-${usedItem.nodeId}`}
                            lineId={lineId}
                            menuId={menuId}
                            usedModifiers={usedItem.usedModifiers[mo]}
                            bindingId={mo}
                            itemQuantity={usedItem.quantity * itemQuantity}
                            isOrderLinedVoided={isOrderLineVoided}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}
